import SyntheseControleController from './synthese.controle.controller';

export default {
    bindings: {
        model: '='
    },
    controller: SyntheseControleController,
    template: require('./synthese.controle.tpl.html')
};
